import services from 'utils/mockAdapter';
// user list
const VarValuesList = [
    {
        id: '10011',
        value: '0 ',
        description: 'The Elevator Door Is Closed',
        errortype: '',
        errordescription: '',
        microhelp: '',
        notify: '0'
    },
    {
        id: '10011',
        value: '1',
        description: 'The Elevator Door Is Opend',
        errortype: '',
        errordescription: '',
        microhelp: '',
        notify: '0'
    },
    {
        id: '10011',
        value: '2',
        description: 'The Elevator Door Is Stuck',
        errortype: 'Alert',
        errordescription: 'The Elevetor Door is in Error',
        microhelp: 'Try To Rest the Elevator',
        notify: '1'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/varvalues/list').reply(200, { VarValuesList });
